import Trans from 'next-translate/Trans';
import Link from 'next/link';
import style from '../LicensingModal.module.css';

const SupportLink = () => (
	<Link
		key="mail-support"
		type="danger"
		className={style.supportLink}
		href="mailto:support@automatic.tv"
	>
		<Trans i18nKey="cameras:supportEmail"></Trans>
	</Link>
);

export const errorsOptions = {
	404: {
		/**
		 * System is being rebooted
		 */
		151: {
			hasError: true,
			message: () => (
				<Trans i18nKey="cameras:licensingModal.errors.rebooting"></Trans>
			),
		},
	},
	400: {
		/**
		 *  Invalid ticket ID
		 */
		1012: {
			hasError: true,
			message: () => (
				<Trans
					i18nKey="cameras:licensingModal.errors.process"
					components={[<SupportLink key="mail-support" />]}
				/>
			),
		},
		/**
		 *  Invalid license for device type
		 */
		1015: {
			hasError: true,
			message: () => (
				<Trans
					i18nKey="cameras:licensingModal.errors.notValid"
					components={[<SupportLink key="mail-support" />]}
				/>
			),
		},
		/**
		 *  Already used license
		 */
		1016: {
			hasError: true,
			message: () => (
				<Trans
					i18nKey="cameras:licensingModal.errors.alreadyActivated"
					components={[<SupportLink key="mail-support" />]}
				/>
			),
		},
	},
};
